import * as React from "react";
import {Component, Fragment} from "react";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import {History} from "history";
import {SubjectMerge} from "../../../models/SubjectMerge";
import {SubjectExcludes} from "../../../models/SchoolWorkloadConfig";
import SdsSubject from "../../../models/SdsSubject";
import {MessageBarType, PrimaryButton} from "office-ui-fabric-react";
import Actions from "../../../redux/Actions";
import HelpBox from "./HelpBox";

export interface BaseConfigureSubjectMergesPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    history: History;
}

export interface BaseConfigureSubjectMergesPageState {
    
    subjectMerges?: SubjectMerge[];
    subjectExcludes?: SubjectExcludes;
    sdsSubjects?: SdsSubject[];
    saveInProgress: boolean;

    helpTitleText: string;
    helpContent: JSX.Element;
    helpIcon: string;

}

export abstract class BaseConfigureSubjectMergesPage extends Component<BaseConfigureSubjectMergesPageProps & DispatchProps, BaseConfigureSubjectMergesPageState> {

    protected constructor(props: BaseConfigureSubjectMergesPageProps & DispatchProps) {
        super(props);
    }

    async componentDidMount(): Promise<void> {
        await this.getMerges();
    }

    async componentDidUpdate(prevProps: Readonly<BaseConfigureSubjectMergesPageProps & DispatchProps>, prevState: any): Promise<void> {

        if(this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode)
        {
            await this.getMerges();
        }
    }

    private async getMerges() {

        if (!this.props.tenantId || !this.props.schoolCode) {
            return;
        }

        const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);
        const subjectMerges = await this.props.apiService.getSubjectMergesForSchool(this.props.tenantId, this.props.schoolCode);
        const sdsSubjects = await this.props.apiService.getSdsSubjectsForSchool(this.props.tenantId, this.props.schoolCode);
        this.setState({
            subjectExcludes: schoolWorkloadConfig.subjectExcludes,
            subjectMerges,
            sdsSubjects
        });
    }

    public saveMerges = async () =>
    {
        if(!this.props.tenantId || !this.props.schoolCode || this.state.subjectMerges === undefined)
        {
            return;
        }

        this.setState({
            saveInProgress: true
        });

        try
        {
            const savedSubjectMerges = await this.props.apiService.putSubjectMergesForSchool(this.props.tenantId, this.props.schoolCode, this.state.subjectMerges);
            await this.props.dispatch(Actions.showMessageBar("Saved subject merges to config",MessageBarType.success));

            this.setState({
                subjectMerges: savedSubjectMerges
            });
        }
        catch (e)
        {
            let message = "Failed to save subject merges : " + e.message;
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(message, MessageBarType.error));
        }

        this.setState({
            saveInProgress: false
        });
    }

    protected abstract renderContent(): JSX.Element;
    
    public render(): JSX.Element {
        return (
            <Fragment>
                <HelpBox
                    TitleText={this.state.helpTitleText}
                    HelpBoxText={this.state.helpContent}
                    Icon={this.state.helpIcon}
                />
                {this.renderContent()}
                <div className="flex-item--flex-2 flex-row">
                    <PrimaryButton style={{ margin: "auto" }} onClick={this.saveMerges} text={`Save Changes`} disabled={this.state.saveInProgress} />
                </div>
            </Fragment>
        );
    }
}